import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ListDeviceSupportComponent } from './list-device-support/list-device-support.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ListDeviceSupportComponentNoAuthComponent } from './list-device-support-no-auth/list-device-support-no-auth.component';

@NgModule({
    declarations: [ListDeviceSupportComponent, ListDeviceSupportComponentNoAuthComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        ButtonModule,
        TableModule,
        InputTextModule,
    ],
    exports: [
        ListDeviceSupportComponent,
        ListDeviceSupportComponentNoAuthComponent
    ]
})
export class ListDeviceSupportModule { }
